import React from 'react';
import { Box } from "@mui/material";
import { Divider } from "@mui/material";
import GetfVDateFormate from "../../utils/Genaricfunctions";
import { useTranslation } from "react-i18next";
import "../../Localization/i18n";

export default function VendorCompleted(props) {
  const { t } = useTranslation();
  return (
    <>
      <Box border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec" className="mt-3" sx={{ width: "auto", padding: "10px" }} key={props?.compleated?.fullName}>
        <h6
          className="card-title "
          style={{
            fontWeight: "bold",
            fontSize: "17px",
            marginBottom: 10,
            color: "#667085",
          }}
        >
          {props?.compleated?.fullName}
        </h6>
        <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
        <h6
          className="card-subtitle"
          style={{
            fontSize: "15px",
            color: "#101828",
            marginBottom: 5,
            marginTop: 10,
            fontWeight: "400",
          }}
        >
          {props?.compleated?.contactTile}
        </h6>
        <h6
          style={{
            fontSize: "15px",
            color: "#101828",
            marginBottom: 5,
            fontWeight: "400",
          }}
        >
          {GetfVDateFormate("", props?.compleated?.statusChangeDate)} {t('VendorDetails.label31')}
          {/* {new Date(props.compleated.statusChangeDate).toLocaleString("en-US")} */}
        </h6>
        <h6
          style={{
            fontSize: "15px",
            color: "#101828",
            marginBottom: 5,
            fontWeight: "400",
          }}
        >
          {props?.start?.prequalificationSubmit}
          {GetfVDateFormate("", props?.start?.prequalificationStart)} {t('VendorDetails.label32')}
          {/* {new Date(props.start.prequalificationStart).toLocaleString("en-US")}  */}
        </h6>
      </Box>
    </>
  )
}
